
import React from 'react';

function Footer() {
  return (
    <div className="footer-container">
      <div className="sns-icons">
        <a href="https://www.instagram.com/yos2n/" target="_blank" rel="noopener noreferrer">
          <img src="data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMzIiIGhlaWdodD0iMzIiIHZpZXdCb3g9IjAgMCAzMiAzMiIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KICAgIDxnIGZpbGw9Im5vbmUiIGZpbGwtcnVsZT0iZXZlbm9kZCI+CiAgICAgICAgPHBhdGggZD0iTTAgMGgzMnYzMkgweiIvPgogICAgICAgIDxyZWN0IHN0cm9rZT0iIzM0MzQzNCIgc3Ryb2tlLXdpZHRoPSIxLjI1IiB4PSI2LjYyNSIgeT0iNi42MjUiIHdpZHRoPSIxOC43NSIgaGVpZ2h0PSIxOC43NSIgcng9IjYiLz4KICAgICAgICA8Y2lyY2xlIGZpbGw9IiMzNDM0MzQiIGN4PSIyMSIgY3k9IjExIiByPSIxIi8+CiAgICAgICAgPHJlY3Qgc3Ryb2tlPSIjMzQzNDM0IiBzdHJva2Utd2lkdGg9IjEuMjUiIHg9IjExLjYyNSIgeT0iMTEuNjI1IiB3aWR0aD0iOC43NSIgaGVpZ2h0PSI4Ljc1IiByeD0iNC4zNzUiLz4KICAgIDwvZz4KPC9zdmc+Cg==" alt="Instagram" />
        </a>
      </div>
    </div>
  );
}

export default Footer;
